import React from 'react';
import { useStore } from '../store';

const MODULES = {
  school: {
    color: '#6366f1', icon: '◬', label: 'Cognira School',
    screens: [
      { id: 'dashboard',   label: 'Dashboard',        icon: '⬡' },
      { id: 'students',    label: 'Students',          icon: '◉' },
      { id: 'attendance',  label: 'Attendance',        icon: '◫' },
      { id: 'fees',        label: 'Fee Collection',    icon: '◎' },
      { id: 'exams',       label: 'Exams & Results',   icon: '◈' },
      { id: 'reportcards', label: 'Report Cards',      icon: '⬡' },
      { id: 'staff',       label: 'Staff',             icon: '◉' },
      { id: 'certificates',label: 'Certificates',      icon: '◫' },
      { id: 'library',     label: 'Library',           icon: '◎' },
    ]
  },
  hospital: {
    color: '#ef4444', icon: '◎', label: 'Cognira Hospital',
    screens: [
      { id: 'dashboard',    label: 'Dashboard',        icon: '⬡' },
      { id: 'patients',     label: 'Patients',         icon: '◉' },
      { id: 'doctors',      label: 'Doctors',          icon: '◫' },
      { id: 'appointments', label: 'Appointments',     icon: '◎' },
      { id: 'prescriptions',label: 'Prescriptions',    icon: '◈' },
      { id: 'lab',          label: 'Lab Tests',        icon: '⬡' },
      { id: 'pharmacy',     label: 'Pharmacy',         icon: '◉' },
      { id: 'billing',      label: 'Billing',          icon: '◫' },
    ]
  },
  pos: {
    color: '#10b981', icon: '◈', label: 'Cognira POS',
    screens: [
      { id: 'dashboard',  label: 'Dashboard',          icon: '⬡' },
      { id: 'sell',       label: 'Point of Sale',      icon: '◉' },
      { id: 'products',   label: 'Products',           icon: '◫' },
      { id: 'orders',     label: 'Orders',             icon: '◎' },
      { id: 'inventory',  label: 'Inventory',          icon: '◈' },
      { id: 'reports',    label: 'Sales Reports',      icon: '⬡' },
    ]
  },
  restaurant: {
    color: '#f97316', icon: '◫', label: 'Cognira Restaurant',
    screens: [
      { id: 'dashboard',  label: 'Dashboard',          icon: '⬡' },
      { id: 'tables',     label: 'Table Management',   icon: '◉' },
      { id: 'orders',     label: 'Orders',             icon: '◫' },
      { id: 'kitchen',    label: 'Kitchen Display',    icon: '◎' },
      { id: 'menu',       label: 'Menu Management',    icon: '◈' },
      { id: 'billing',    label: 'Billing',            icon: '⬡' },
    ]
  },
  hotel: {
    color: '#8b5cf6', icon: '⬡', label: 'Cognira Hotel',
    screens: [
      { id: 'dashboard',  label: 'Dashboard',          icon: '⬡' },
      { id: 'rooms',      label: 'Rooms',              icon: '◉' },
      { id: 'bookings',   label: 'Bookings',           icon: '◫' },
      { id: 'checkin',    label: 'Check In/Out',       icon: '◎' },
      { id: 'billing',    label: 'Billing',            icon: '◈' },
    ]
  },
  ngo: {
    color: '#f59e0b', icon: '◉', label: 'Cognira NGO',
    screens: [
      { id: 'dashboard',   label: 'Dashboard',         icon: '⬡' },
      { id: 'beneficiaries',label:'Beneficiaries',     icon: '◉' },
      { id: 'programs',    label: 'Programs',          icon: '◫' },
      { id: 'donations',   label: 'Donations',         icon: '◎' },
      { id: 'volunteers',  label: 'Volunteers',        icon: '◈' },
    ]
  },
};

export { MODULES };

export default function Sidebar() {
  const { module, setModule, activeScreen, setScreen, online, pendingSync, user, logout } = useStore();
  const currentModule = MODULES[module] || MODULES.school;
  const color = currentModule.color;

  return (
    <div style={{
      width: 230, background: '#0d0d1a',
      borderRight: '1px solid #1e1e3a',
      display: 'flex', flexDirection: 'column',
      height: '100vh'
    }}>
      {/* Logo */}
      <div style={{ padding: '18px 16px', borderBottom: '1px solid #1e1e3a' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div style={{
            width: 38, height: 38, borderRadius: 12,
            background: `linear-gradient(135deg, ${color}, #8b5cf6)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 16, fontWeight: 900, color: '#fff'
          }}>C</div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 800, color: '#fff' }}>Cognira</div>
            <div style={{ fontSize: 10, color: color }}>by VGO Global</div>
          </div>
        </div>

        {/* Online/offline indicator */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '6px 10px',
          background: online ? '#10b98111' : '#f59e0b11',
          border: `1px solid ${online ? '#10b98133' : '#f59e0b33'}`,
          borderRadius: 8
        }}>
          <div style={{
            width: 6, height: 6, borderRadius: '50%',
            background: online ? '#10b981' : '#f59e0b'
          }} />
          <span style={{ fontSize: 11, color: online ? '#10b981' : '#f59e0b' }}>
            {online ? 'Online' : `Offline${pendingSync > 0 ? ` · ${pendingSync} pending` : ''}`}
          </span>
        </div>
      </div>

      {/* Module switcher */}
      <div style={{ padding: '10px 8px', borderBottom: '1px solid #1e1e3a' }}>
        <div style={{ fontSize: 10, color: '#333', letterSpacing: 2, marginBottom: 6, paddingLeft: 8 }}>
          MODULE
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
          {Object.entries(MODULES).map(([id, m]) => (
            <button key={id} onClick={() => setModule(id)} title={m.label} style={{
              padding: '5px 8px',
              background: module === id ? m.color + '22' : 'transparent',
              border: `1px solid ${module === id ? m.color + '66' : '#1e1e3a'}`,
              borderRadius: 6, color: module === id ? m.color : '#444',
              fontSize: 11, cursor: 'pointer', fontWeight: module === id ? 600 : 400
            }}>{m.icon} {id.slice(0,3).toUpperCase()}</button>
          ))}
        </div>
      </div>

      {/* Navigation */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
        <div style={{
          fontSize: 10, color: '#333', letterSpacing: 2,
          padding: '8px 16px 4px', textTransform: 'uppercase'
        }}>{currentModule.label}</div>

        {currentModule.screens.map(s => (
          <button key={s.id} onClick={() => setScreen(s.id)} style={{
            width: '100%', padding: '9px 16px',
            background: activeScreen === s.id ? color + '22' : 'transparent',
            border: 'none',
            borderLeft: activeScreen === s.id ? `3px solid ${color}` : '3px solid transparent',
            display: 'flex', alignItems: 'center', gap: 10,
            cursor: 'pointer', textAlign: 'left'
          }}>
            <span style={{ color: activeScreen === s.id ? color : '#555', fontSize: 15 }}>
              {s.icon}
            </span>
            <span style={{
              fontSize: 13,
              color: activeScreen === s.id ? '#fff' : '#666',
              fontWeight: activeScreen === s.id ? 600 : 400
            }}>{s.label}</span>
          </button>
        ))}
      </div>

      {/* User + logout */}
      <div style={{ padding: '12px 16px', borderTop: '1px solid #1e1e3a' }}>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
          {user?.email || 'cognira@vgo.global'}
        </div>
        <button onClick={logout} style={{
          width: '100%', padding: '8px',
          background: 'transparent', border: '1px solid #ef444433',
          borderRadius: 8, color: '#ef4444',
          fontSize: 12, cursor: 'pointer'
        }}>Sign Out</button>
      </div>
    </div>
  );
}
